import { z } from 'zod';
import { RoleCode } from '../../enums/enum.js';
const organizationList = z.object({
    id: z.number(),
    name: z.string(),
    storeCount: z.number(),
    createdOn: z.string().nullable(),
});
const orgUserList = z.object({
    id: z.number(),
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    roleCode: z.enum(RoleCode),
    createdOn: z.string().nullable(),
});
const organizationBase = organizationList.extend({
    users: z.array(orgUserList),
});
export const commandOrganization = {
    base: organizationBase,
    list: organizationList,
    userList: orgUserList,
    create: organizationList.pick({ name: true }),
};
//# sourceMappingURL=organizations.js.map